import { computed, useContext, useRoute } from "@nuxtjs/composition-api";
import { FEATURES } from "~/config/pages/features.config";
import { capitalizeFirstLetter } from "~/helpers/jsutil";
import { getPageType } from "~/helpers/professionNavLinks";
import { useProfessionNavLinksStore } from "~/stores/professionNavLinks";

export function useProfessionNavLinks() {
  const { $branding, $pinia, store, i18n, localePath } = useContext();
  const route = useRoute();
  const navLinksStore = useProfessionNavLinksStore($pinia);

  const profession = computed(() => {
    if (
      !$branding.hasFeature(FEATURES.DYNAMIC_NAV_LINKS) ||
      !getPageType(route.value.name)
    ) {
      return null;
    }

    const listPageProfession = store.getters["listPage/profession"];
    if (
      !listPageProfession?.seoName ||
      listPageProfession.seoName !== navLinksStore.professionSeoName
    ) {
      return null;
    }

    return listPageProfession;
  });

  const professionMenu = computed(() => {
    if (!profession.value?.plural || !navLinksStore.headerItems.length) {
      return null;
    }

    return {
      text: capitalizeFirstLetter(profession.value.plural),
      items: [
        {
          id: "profession-all",
          icon: "list-ol",
          text: i18n.t("navbar.professions.all"),
          to: localePath({ name: "professionsLandingPage" }),
        },
        ...navLinksStore.headerItems.map((item) => ({
          ...item,
          icon: "arrow-right",
        })),
      ],
    };
  });

  const pricesMenu = computed(() => {
    if (!profession.value?.name || !navLinksStore.pricesItems.length) {
      return null;
    }

    return {
      text: i18n.t("navbar.professionTasks.professionLabel", {
        profession: capitalizeFirstLetter(profession.value.name),
      }),
      items: [
        {
          id: "profession-task-all",
          icon: "list-ol",
          text: i18n.t("navbar.professionTasks.all"),
          to: localePath({ name: "pricesPage" }),
        },
        ...navLinksStore.pricesItems.map((item) => ({
          ...item,
          icon: "arrow-right",
        })),
      ],
    };
  });

  const footerItems = computed(() => {
    if (!profession.value || !navLinksStore.footerItems.length) {
      return null;
    }
    return navLinksStore.footerItems;
  });

  return { professionMenu, pricesMenu, footerItems };
}
